























































import Vue from "vue";
import EditSelection from "@/components/end_parts/EditSelection.vue";

export default Vue.extend({
  components: {
    EditSelection,
  },
  props: {
    selectionBoxParam: {
      type: Object,
      default: Object,
    },
    selectionBoxKey: {
      type: String,
      default: String,
    },
    columnskey: {
      type: String,
      default: String,
    },
    selectionBoxTransform: {
      type: String,
      default: String,
    },
    inputThirdHeader: {
      type: Number,
      default: Number,
    },
    selectionBoxIndex: {
      type: Number,
      default: Number,
    },
    selectionBoxArray: {
      type: Array,
      default: Array,
    },
  },
  data() {
    return {
      JsonParam: "",
    };
  },
  watch: {
    selectionBoxParam: {
      handler() {
        this.reload();
      },
      deep: true,
    },
  },
  created() {
    this.reload();
  },
  methods: {
    reload() {
      this.JsonParam = this.selectionBoxParam[this.selectionBoxKey];
    },
    RunAlert() {
      alert("OK");
    },
  },
});
